import React, { useEffect, useState } from "react";
import {
	CircularProgress,
	Table,
	TableBody,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import UpIcon from '@material-ui/icons/KeyboardArrowUp';
import { FormattedMessage, useIntl } from 'react-intl';
import jzip from 'xlsx/dist/jszip';
import 'xlsx/dist/xlsx.full.min.js';
import SortAsc from "../../assets/images/llantas/table/sort-asc.svg";
import SortDesc from "../../assets/images/llantas/table/sort-desc.svg";
import Sort from "../../assets/images/llantas/table/sort.svg";
import Security from '../../commons/security/Security.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js';
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles';
import * as Utils from '../../commons/utils/Utils';
import ReportesGridRow from './ReportesGridRow.jsx';
import ReportesGridFilters from './ReportesGridFilters.jsx';
import backendStrings from '../../lang/backendStrings.js';
import { Redirect } from 'react-router-dom'

window.JSZip = jzip;

const PAGINATION_INIT ={
	page: 0,
	count: 0,
	perPage: 10,
}

const FILTER_QUERY_INIT = {
	id: '',
	fecha: '',
	tipoRelato: '',
	evento: '',
	base: '',
	conductor:'',
	dominio: '',
	estado: 'PENDIENTE'
}

const SORT_QUERY_INIT = {
	id: 'desc',
	fecha: '',
	tipoRelato: '',
	evento: '',
	base: '',
	conductor:'',
	dominio: '',
	transportadora: '',
	centroCostos: ''
}

const getStorage = () =>{
	let storage = JSON.parse(window.localStorage.getItem('SafeFeedbackReportesGridFilter'))
	if(storage && storage.activo){
		return true
	}
	else{
		return false
	}
}

const ReportesGrid = (props) => {
	const intl = useIntl()

	const [loading, setLoading] = useState(false)
	const [redirectTo, setRedirectTo] = useState(null)
	const [searchActive, setSearchActive] = useState(false)
	const [pagination, setPagination] = useState(JSON.parse(JSON.stringify(PAGINATION_INIT)))
	const [paginationCount, setPaginationCount] = useState(0);
	const [persisteFiltros, setPersisteFiltros] = useState(getStorage())
	const [filterResetInputs, setFilterResetInputs] = useState(false)
	const [filterQuery, setFilterQuery] = useState(JSON.parse(JSON.stringify(FILTER_QUERY_INIT)))
	const [sortQuery, setSortQuery] = useState(JSON.parse(JSON.stringify(SORT_QUERY_INIT)))
	const [dropdownActive, setDropdownActive] = useState(false);
	const [dataGrid, setDataGrid] = useState([]);
	const [alertsClicked, setAlertsClicked] = useState([]);
	const [summaryAlerts, setSummaryAlerts] = useState(null);
	const [filterKpi, setFilterKpi] = useState(null);

	const transportadoraGrilla = ConfigBusiness.get('moviles.transportadora.grilla') === 'true';

	useEffect(() => {
		setLoading(true)
		if (Security.hasPermission("SAFEFEEDBACK_LISTAR")) {
			filterQuery && init()
		} else {
			setRedirectTo("/error")
		}
		return () => { }
	}, [pagination, filterQuery, sortQuery])

	const init = () => {
		const disponibilidadGridReq = Utils.getData(`/safeFeedback${getQuery()}`);
		const controlesGridReq = Utils.getData(`/safeFeedback/controles/alarmas`);
		Promise.all([disponibilidadGridReq, controlesGridReq])
			.then(([disponibilidadGrid, controlesGrid]) => {
				setDataGrid(Array.isArray(disponibilidadGrid.reportes) ? disponibilidadGrid.reportes : []);
				setPaginationCount(disponibilidadGrid.pagination ? disponibilidadGrid.pagination.count : 0);
				setSummaryAlerts(controlesGrid);
				setLoading(false);
			})
			.catch((err) => {
				setLoading(false)
			})
	};

	const reloadData = () => {
		setLoading(true);
		init()
	};

	const safeParam = (v) =>
		v === null || v === undefined || v === '' ? '' : encodeURIComponent(v);	  

	const getQuery = () => {
		const q = filterQuery || {};
		const base = (q.base && typeof q.base === 'object' && 'value' in q.base) ? q.base.value : (q.base || '');
		const estado = (q.estado && typeof q.estado === 'object' && 'value' in q.estado) ? q.estado.value : (q.estado || 'PENDIENTE');
		let myQuery = "?page=" + pagination.page
		myQuery += "&perPage=" + pagination.perPage

		myQuery += "&dominio=" + safeParam(q.dominio);
		myQuery += "&id=" + safeParam(q.id);
		myQuery += "&fecha=" + safeParam(q.fecha);
		myQuery += "&tipoRelato=" + safeParam(q.tipoRelato);
		myQuery += "&evento=" + safeParam(q.evento);
		myQuery += "&base=" + base;
		myQuery += "&conductor=" + safeParam(q.conductor);
		myQuery += "&estado=" + estado;
		if (transportadoraGrilla) {
		myQuery += "&transportadora=" + safeParam(q.transportadora || '');
		myQuery += "&centroCostos=" + safeParam(q.centroCostos || '');
		}

		myQuery += "&dominioSort=" + safeParam(sortQuery.dominio);
		myQuery += "&idSort=" + safeParam(sortQuery.id);
		myQuery += "&fechaSort=" + safeParam(sortQuery.fecha);
		myQuery += "&tipoRelatoSort=" + safeParam(sortQuery.tipoRelato);
		myQuery += "&eventoSort=" + safeParam(sortQuery.evento);
		myQuery += "&baseSort=" + safeParam(sortQuery.base);
		myQuery += "&conductorSort=" + safeParam(sortQuery.conductor);
		if (transportadoraGrilla) {
			myQuery += "&transportadoraSort=" + safeParam(sortQuery.transportadora);
			myQuery += "&centroCostosSort=" + safeParam(sortQuery.centroCostos);
		}

		return myQuery;
	}

	const handleChangePage = (event, newPage) => {
		setPagination({ ...pagination, page: newPage });
	}

	const handleChangeRowsPerPage = (event) => {
		setPagination({ ...pagination, perPage: parseInt(event.target.value, 10), page: 0 });
	}

	const requestSort = (key) => {
		let query = { ...sortQuery }
		let aux = sortQuery[key];
		query["id"] = "";
		query["dominio"] = "";
		query["fecha"] = "";
		query["tipoRelato"] = "";
		query["evento"] = "";
		query["base"] = "";
		query["conductor"] = "";
		query["estado"] = "";
		query["transportadora"] = "";
		query["centroCostos"] = "";

		pagination.page = 0;

		if (!aux) query[key] = "asc";
		else if (aux === "desc") query[key] = "asc";
		else query[key] = "desc";
		setSortQuery(query);
	};

	const handleFilterReset = () => {
		setPagination(JSON.parse(JSON.stringify(PAGINATION_INIT)));
		setFilterQuery(JSON.parse(JSON.stringify(FILTER_QUERY_INIT)));
		setSortQuery(JSON.parse(JSON.stringify(SORT_QUERY_INIT)));
		setDropdownActive(false);
		setSearchActive(false);
		setAlertsClicked([])
		setPersisteFiltros(false)
		setFilterResetInputs(true)
	}

	const handleAlertClick = (filter) => {
		let copyClicked = alertsClicked;
		let reset = false;
		if (alertsClicked[filter]) {
			reset = true;
			copyClicked[filter] = !alertsClicked[filter];
		} else {
			for (let alarm in alertsClicked) {
				copyClicked[alarm] = false;
			}
			copyClicked[filter] = true;
		}

		setAlertsClicked(copyClicked)

		let query = { ...filterQuery };
		query['filtroKpi'] = reset ? "" : filter;
		setFilterQuery(query);
	}

	const handleFilterChange = () => {
		setPagination(prevState => ({ ...prevState, page: 0 }));
	}

	const handleFilterDashboard = (filter) => {

		switch (filter) {
			case 'PENDIENTE':
				filterQuery.estado = 'PENDIENTE';
				break;
			case 'CONFIRMADO':
				filterQuery.estado = 'CONFIRMADO';
				break;
			case 'DESESTIMADO':
				filterQuery.estado = 'DESESTIMADO';
			break;
			default:
				break;
	  	}
		setFilterKpi(filter);
	  	reloadData();
	}

	return (
		<>
			{redirectTo && <Redirect push to={redirectTo} />}
			{summaryAlerts ?
				<section className="combustiblesWidget">
					<div className="row justify-content-around">
						{summaryAlerts.map((alert, index)=>{
							return(
								<div key={index} className={"col-xl-4 col-lg-6 col-12"} style={{ paddingRight: "0.5rem", paddingLeft: "0.5rem" }}>
									<div className="card pull-up">  
										<div className="card-content" style={{ cursor: alert.cursor }}>
											<div style={{padding: "15px"}} className="card-body"  onClick={alert.cursor === 'pointer' ? (e) => handleFilterDashboard(alert.filter) : null}>
												<div className="media d-flex">
													<div className="align-self-center">
														<i className={alert.iconClass} style={{color: alert.iconColor}}></i>
													</div>
													<div className="media-body text-right">
														<span><FormattedMessage {...(backendStrings[alert.description] ? backendStrings[alert.description] : backendStrings['errors.default'])}/></span>
														<h3><b>{!alert.value ? 0 : alert.value }</b></h3>
													</div>
												</div>
												
											</div> 
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</section>
			: ''}
			<div className="card">
				<div className="card-content collpase show">
					<div className="card-body card-dashboard">
						<div className="container-fluid mb-1">
							<div className="row dt-icons" style={{ width: '100%' }}>
								<div className="col">
									<div
										className="btn btn-grey-blue box-shadow-2 btn-round btn-lg btn-dt-main round-icon"
										style={{ height: 52, marginLeft: '-13px', marginTop: '6px' }}
										onClick={() => setDropdownActive(!dropdownActive)}
									>
										{dropdownActive ? <UpIcon /> : <ExpandMoreIcon />}
									</div>
								</div>
								<div className="col">
									{searchActive && (
										<div className="btn-dt-main round-icon">
											<div
												className="text-center"
												style={{
													height: '25px',
													borderRadius: '3px',
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													paddingLeft: '8px',
													backgroundColor: '#5AAC43',
													color: 'white',
												}}
											>
												<div
													className="text-center"
													style={{
														width: '100%',
														fontSize: '12px',
														fontWeight: '500',
													}}
												>
													{dataGrid.length} de {paginationCount} resultados de busqueda
												</div>
												<div className="resultados-busqueda-notif">
													<i
														className="las la-times la-xs cursor-pointer"
														onClick={() => handleFilterReset()}
													></i>
												</div>
											</div>
										</div>
									)}
								</div>
								<div className="col">
								</div>
							</div>
						</div>
						
						<ReportesGridFilters
							dropdownActive={dropdownActive}
							setDropdownActive={setDropdownActive}
							persisteFiltros={persisteFiltros}
							setPersisteFiltros={setPersisteFiltros}
							filterResetInputs={filterResetInputs}
							setFilterResetInputs={setFilterResetInputs}
							filterQuery={filterQuery}
							setFilterQuery={setFilterQuery}
							searchActive={searchActive}
							setSearchActive={setSearchActive}
							loading={loading}
							pagination={pagination}
							kpi={props.location && props.location.state}
							handleAlertClick={handleAlertClick}
							handleFilterChange={handleFilterChange}
							filterKpi={filterKpi}
							setRedirectTo={setRedirectTo}
							transportadoraGrilla={transportadoraGrilla}
						/>
						
						<TableContainer>
							<Table aria-label="clases table" className="table-hover">
								<TableHead>
									<TableRow>
										<StyledTableCell align="left" onClick={() => requestSort("id")} style={{ cursor: "pointer" }}>
											<FormattedMessage id="safeFeedback_reportesGrid.rennder.column_id.label" defaultMessage="ID" />
											<img className="ml-1"
												src={sortQuery.id === "" ? Sort : sortQuery.id === "asc" ? SortAsc : SortDesc}
												alt={"/"}
												style={{ height: "12px", width: "22px" }}
											/>
										</StyledTableCell>
										<StyledTableCell align="left" onClick={() => requestSort("fecha")} style={{ cursor: "pointer" }}>
											<FormattedMessage id="safeFeedback_reportesGrid.rennder.column_Fecha.label" defaultMessage="Fecha" />
											<img className="ml-1"
												src={sortQuery.fecha === "" ? Sort : sortQuery.fecha === "asc" ? SortAsc : SortDesc}
												alt={"/"}
												style={{ height: "12px", width: "22px" }}
											/>
										</StyledTableCell>
										<StyledTableCell align="left" onClick={() => requestSort("tipoRelato")} style={{ cursor: "pointer" }}>
											<FormattedMessage id="safeFeedback_reportesGrid.rennder.column_tipo_relato.label" defaultMessage="Tipo de Relato" />
											<img className="ml-1"
												src={sortQuery.tipoRelato === "" ? Sort : sortQuery.tipoRelato === "asc" ? SortAsc : SortDesc}
												alt={"/"}
												style={{ height: "12px", width: "22px" }}
											/>
										</StyledTableCell>
										<StyledTableCell align="left" onClick={() => requestSort("evento")} style={{ cursor: "pointer" }}>
											<FormattedMessage id="safeFeedback_reportesGrid.rennder.column_evento.label" defaultMessage="Evento" />
											<img className="ml-1"
												src={sortQuery.evento === "" ? Sort : sortQuery.evento === "asc" ? SortAsc : SortDesc}
												alt={"/"}
												style={{ height: "12px", width: "22px" }}
											/>
										</StyledTableCell>
										<StyledTableCell align="left" onClick={() => requestSort("base")} style={{ cursor: "pointer" }}>
											<FormattedMessage id="safeFeedback_reportesGrid.rennder.column_base.label" defaultMessage="Base" />
											<img className="ml-1"
												src={sortQuery.base === "" ? Sort : sortQuery.base === "asc" ? SortAsc : SortDesc}
												alt={"/"}
												style={{ height: "12px", width: "22px" }}
											/>
										</StyledTableCell>
										<StyledTableCell align="left" onClick={() => requestSort("conductor")} style={{ cursor: "pointer" }}>
											<FormattedMessage id="safeFeedback_reportesGrid.rennder.column_conductor.label" defaultMessage="Conductor" />
											<img className="ml-1"
												src={sortQuery.conductor === "" ? Sort : sortQuery.conductor === "asc" ? SortAsc : SortDesc}
												alt={"/"}
												style={{ height: "12px", width: "22px" }}
											/>
										</StyledTableCell>
										<StyledTableCell align="left" onClick={() => requestSort("dominio")} style={{ cursor: "pointer" }}>
											<FormattedMessage id="safeFeedback_reportesGrid.rennder.column_dominio.label" defaultMessage="Placa" />
											<img className="ml-1"
												src={sortQuery.dominio === "" ? Sort : sortQuery.dominio === "asc" ? SortAsc : SortDesc}
												alt={"/"}
												style={{ height: "12px", width: "22px" }}
											/>
										</StyledTableCell>
										{transportadoraGrilla && (
											<>
												<StyledTableCell align="left" onClick={() => requestSort("transportadora")} style={{ cursor: "pointer" }}>
													<FormattedMessage id="safeFeedback_reportesGrid.rennder.column_transportadora.label" defaultMessage="Transportadora" />
													<img className="ml-1"
														src={sortQuery.transportadora === "" ? Sort : sortQuery.transportadora === "asc" ? SortAsc : SortDesc}
														alt={"/"}
														style={{ height: "12px", width: "22px" }}
													/>
												</StyledTableCell>
												<StyledTableCell align="left" onClick={() => requestSort("centroCostos")} style={{ cursor: "pointer" }}>
													<FormattedMessage id="safeFeedback_reportesGrid.rennder.column_centro_costos.label" defaultMessage="Centro de costos" />
													<img className="ml-1"
														src={sortQuery.centroCostos === "" ? Sort : sortQuery.centroCostos === "asc" ? SortAsc : SortDesc}
														alt={"/"}
														style={{ height: "12px", width: "22px" }}
													/>
												</StyledTableCell>
											</>
										)}
										<StyledTableCell align="left">
											<FormattedMessage id="safeFeedback_reportesGrid.rennder.column_acciones.label" defaultMessage="Acciones" />
										</StyledTableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{loading && (
										<TableRow>
											<StyledTableCell colSpan={transportadoraGrilla ? 11 : 9} align="center">
												<CircularProgress />
											</StyledTableCell>
										</TableRow>
									)}
									{!loading &&
										(dataGrid.length > 0 ?
											dataGrid.map((data) => (
												<ReportesGridRow
													key={'reportesGridRow_' + data.id}
													baseUrl={props.match.url}
													data={data}
													loading={loading}
													setLoading={setLoading}
													reloadData={reloadData}
													showTransportadoraColumns={transportadoraGrilla}
												/>
											))
											:
											<TableRow>
												<StyledTableCell colSpan={transportadoraGrilla ? 11 : 9} align="center">
													<FormattedMessage id="disponibilidadGrid.rennder.no_data_table" defaultMessage="No se encontraron resultados..." />
												</StyledTableCell>
											</TableRow>
										)}
								</TableBody>
							</Table>
						</TableContainer>
						<TablePagination
							rowsPerPageOptions={[5, 10, 25, 50, 100]}
							component="div"
							count={paginationCount}
							rowsPerPage={pagination.perPage}
							page={pagination.page}
							onPageChange={handleChangePage}
							onRowsPerPageChange={handleChangeRowsPerPage}
							labelRowsPerPage="Mostrar"
							labelDisplayedRows={({ from, to, count }) => `Mostrando ${from} a ${to} de ${count}`}
						/>
					</div>
				</div>
			</div>
		</>
	)
}

export default ReportesGrid